// utils/topMoviesDraft.js
//
// The in-progress My Top Movies ranking on web. The rules (Top 5 / Top 10,
// no duplicates, set-aside instead of delete) live in @aluvo/constants so web
// and mobile behave the same; this file adds localStorage persistence, so
// nobody loses their picks to a refresh, a network error or the sign-up detour.
import { TOP_MOVIES_DRAFT_STORAGE_KEY, normalizeStoredDraft } from '@aluvo/constants/src/topMovies';

export {
    TOP_MOVIES_SIZES, emptyDraft, toMovie, isComplete, hasMovie, addMovie, removeMovie, moveMovie,
    overflowFor, setSize, discardSetAside, setRanked, draftFromSaved, matchesSaved,
} from '@aluvo/constants/src/topMovies';

const defaultStorage = () => (typeof window !== 'undefined' ? window.localStorage : null);

export function loadDraft(storage = defaultStorage()) {
    try {
        return normalizeStoredDraft(JSON.parse(storage?.getItem(TOP_MOVIES_DRAFT_STORAGE_KEY) || 'null'));
    } catch {
        return null;
    }
}

export function saveDraft(draft, storage = defaultStorage()) {
    try {
        storage?.setItem(TOP_MOVIES_DRAFT_STORAGE_KEY, JSON.stringify({ ...draft, updatedAt: new Date().toISOString() }));
    } catch { /* storage full or blocked: the editor still works */ }
}

export function clearDraft(storage = defaultStorage()) {
    try { storage?.removeItem(TOP_MOVIES_DRAFT_STORAGE_KEY); } catch { /* ignore */ }
}
